// @ts-nocheck
export const gtmEvent = ({ event, props }: GoogleTagManagerProps) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer?.push({
    event,
    ...props,
  });
};

export enum GoogleTagManagerEvents {
  NewsletterSignup = "newsletter_sign_up",
  EmbeddedVideoButtonPlay = "embedded_video_button_play",
  RegisterEvent = "register_event",
  WatchEventOnDemand = "watch_event_on_demand",
  HeroPromoButtonClick = "hero_promo_button_click",
  HeroToNewsletterClick = "hero_to_newsletter_click",
  OutboundLinkClick = "outbound_link_click",
}

export type GoogleNewsletterSignUpProps = {
  result: string;
  profession?: string;
  country?: string;
};

export type GoogleOutboundLinkProps = {
  url: string;
};

export type GoogleEmbeddedVideoButtonProps = {
  videoUrl: string;
};

export type GoogleWatchEventProps = {
  title: string;
};

export type GoogleRegisterEventProps = {
  title: string;
  details?: string;
};

export type GoogleHeroPromoButtonProps = {
  action: string;
};

export type GoogleHeroToNewsletterProps = {
  details: string;
};

type GoogleTagManagerEventProps = {
  [GoogleTagManagerEvents.NewsletterSignup]: GoogleNewsletterSignUpProps;
  [GoogleTagManagerEvents.OutboundLinkClick]: GoogleOutboundLinkProps;
  [GoogleTagManagerEvents.EmbeddedVideoButtonPlay]: GoogleEmbeddedVideoButtonProps;
  [GoogleTagManagerEvents.WatchEventOnDemand]: GoogleWatchEventProps;
  [GoogleTagManagerEvents.RegisterEvent]: GoogleRegisterEventProps;
  [GoogleTagManagerEvents.HeroPromoButtonClick]: GoogleHeroPromoButtonProps;
  [GoogleTagManagerEvents.HeroToNewsletterClick]: GoogleHeroToNewsletterProps;
};

export type GoogleTagManagerProps = {
  [Key in GoogleTagManagerEvents]: {
    event: Key;
    props: GoogleTagManagerEventProps[Key];
  };
}[GoogleTagManagerEvents];

export function isGoogleEvent(data: unknown): data is GoogleTagManagerProps {
  return data && typeof data === "object" && "event" in data && "props" in data;
}
